import React from "react";
import Filter from "./Filter";
import FilterDivider from "./FilterDivider";
import * as S from "./styled";
import { IFilterRendererProps, TFilterDividerProps, TFilterProps, TFilterRenderer, TNestedFilter } from "./types";

const isFilterArray = <TQuery extends string>(filter: TFilterRenderer<TQuery>): filter is TNestedFilter<TQuery> => {
    return Array.isArray(filter);
};

const isFilter = <TQuery extends string>(filter: TFilterRenderer<TQuery>): filter is TFilterProps<TQuery> => {
    return !isFilterArray(filter) && (!filter.type || filter.type === "filter");
};

const isDivider = <TQuery extends string>(filter: TFilterRenderer<TQuery>): filter is TFilterDividerProps => {
    return !isFilterArray(filter) && filter.type === "divider";
};

const FiltersRenderer = <TQuery extends string>({
    filters,
    direction = "column"
}: IFilterRendererProps<TQuery>): JSX.Element => {
    const Wrapper = direction === "row" ? S.FilterRow : S.FilterColumn;

    return (
        <>
            {filters.map(
                (filter, index) =>
                    (isFilterArray(filter) || !filter.hidden) && (
                        // eslint-disable-next-line react/no-array-index-key
                        <Wrapper key={index} $divider={isDivider(filter)}>
                            {isFilterArray(filter) && (
                                <FiltersRenderer<TQuery>
                                    direction={direction === "row" ? "column" : "row"}
                                    filters={filter}
                                />
                            )}
                            {isFilter(filter) && <Filter<TQuery> {...filter} />}
                            {isDivider(filter) && <FilterDivider {...filter} orientation={direction} />}
                        </Wrapper>
                    )
            )}
        </>
    );
};
export default FiltersRenderer;
